<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div> {{ form.id ? '编辑分组' : '新建分组' }}</div>
                <div @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask-content-body-cen">
                    <div class="mask-content-body-select">
                        <div class="mask-content-body-select-title">分组名称<span>*</span>：</div>
                        <div class="mask-content-body-select-input">
                            <el-input placeholder="请输入分组名称" v-model="form.name"></el-input>
                        </div>
                    </div>
                    <div class="pc-table pc-table-color">
                        <el-table :row-class-name="tableRowClassName" :data="list" ref="multipleTableW"
                            @selection-change="handleSelectionChange" height="58vh" style="width: 100%" border>
                            <el-table-column fixed type="selection" align="center" width="62"
                                :selectable="selectableStatus">
                            </el-table-column>
                            <el-table-column fixed type="index" align="center" label="序号" width="62">
                            </el-table-column>
                            <!-- <el-table-column fixed prop="date" align="center" label="操作" width="62">
                                <template slot-scope="scope">
                                    <el-popover placement="right" trigger="hover">
                                        <div class="MPopover-list">
                                            <div class="MPopover-item" @click="handleMPopover('编辑班级', scope.row)">
                                                <img src="@/assets/images/icon/edit.png" alt="" />
                                                <div style="color: #2BA471;">编辑班级</div>
                                            </div>
                                            <div class="MPopover-item" @click="handleMPopover('删除班级', scope.row)">
                                                <img src="@/assets/images/icon/remove.png" alt="" />
                                                <div style="color: #777;">删除班级</div>
                                            </div>
                                        </div>
                                        <img slot="reference" class="MPopover-yuan" src="@/assets/images/icon/yuan.png"
                                            alt="" />
                                    </el-popover>
                                </template>
</el-table-column> -->

                            <el-table-column prop="bianhao" label="班级编号" align="center" width="205">
                            </el-table-column>
                            <el-table-column prop="typename" label="班级类型" align="center" width="205"></el-table-column>
                            <el-table-column prop="name" label="班级名称" align="center" width="205">
                            </el-table-column>
                            <el-table-column prop="address" label="班级地点" align="center" width="205"></el-table-column>
                            <el-table-column prop="fee" label="班级费用" width="205" align="center">
                            </el-table-column>
                            <el-table-column prop="name" label="课程状态" width="205" align="center">
                                <template slot-scope="scope">
                                    <div style="color: #C12E30;text-align: center;" v-if="scope.row.coursestatus == 0">
                                        未上传课程</div>
                                    <div style="color: #008858;text-align: center;" v-if="scope.row.coursestatus == 1">
                                        已上传课程</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createtime" label="创建日期" align="center" width="205">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.createtime">
                                        {{ (Number(scope.row.createtime) * 1000) | formatTimestamp("yyyy-MM-dd") }}
                                    </div>
                                    <div v-else>-</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createname" label="创建人" align="center" width="205">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pagination">
                        <div class="pagination-total">共{{ total_count }}条</div>
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="page" :page-sizes="[10, 20, 50, 100, 200, 500, total_count]"
                            :page-size="count" layout="sizes, prev, pager, next, jumper" :total="total_count"
                            background>
                        </el-pagination>
                    </div>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">取消</div>
                    <div @click="handleSubmit">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddGroup",
    props: ['dataVal'],
    data() {
        return {
            banjitype: [],

            page: 1,
            count: 10,
            total_count: 0,
            //表格列表
            list: [],
            //表格选中
            multipleSelection: [],
            disabledlist: [],

            form: {
                activity_id: '',
                id: '',
                name: '',
                banji_ids: ''
            }
        };
    },
    mounted() {
    },
    methods: {
        async activityGroupbanjilist() {
            let obj = {
                activity_id: this.form.activity_id,
                page: this.page,
                count: this.count
            }
            // if (this.form.id) {
            //     obj.group_id = this.form.id
            // }
            let res = await this.$api.activityBanjilist(obj)
            if (res.code == 1) {
                this.multipleSelection = []
                this.disabledlist = []

                res.data.list.forEach(item => {
                    this.banjitype.forEach(v => {
                        if (item.type_id == v.id) {
                            item.typename = v.values
                        }
                    })
                })

                if (this.form.id) {
                    res.data.list.forEach(item => {
                        if (item.group_id && item.group_id != this.form.id) {
                            item.disabled = true
                            this.multipleSelection.push(item.id)
                            this.disabledlist.push(item.id)
                        } else {
                            item.disabled = false
                        }
                    })
                } else {
                    res.data.list.forEach(item => {
                        if (item.group_id) {
                            item.disabled = true
                            this.multipleSelection.push(item.id)
                            this.disabledlist.push(item.id)
                        } else {
                            item.disabled = false
                        }
                    })
                }
                this.list = res.data.list

                if (this.form.id) {
                    this.list.forEach(item => {
                        if (item.group_id == this.form.id) {
                            this.multipleSelection.push(item.id)
                        }
                    })
                }
                // 默认选中
                this.$nextTick(() => {
                    this.list.forEach(item => {
                        this.multipleSelection.forEach(row => {
                            if (item.id == row) {
                                this.$refs.multipleTableW.toggleRowSelection(item, true);
                            }

                        })
                    })

                })
                this.total_count = res.data.total_count
            }
        },
        async dictionaryGetbanjitype() {
            let res = await this.$api.dictionaryGetbanjitype()
            if (res.code == 1) {
                this.banjitype = res.data
                this.activityGroupbanjilist()
            }
        },
        selectableStatus(row, rowIndex) {
            // 如果行数据中有disabled属性，则返回false禁用多选
            return !row.disabled;
        },
        //表格多选
        handleSelectionChange(val) {
            this.multipleSelection = val.map((row) => row.id);
        },
        //分页事件 点击每页多少条
        handleSizeChange(val) {
            this.page = 1
            //console.log(`每页 ${val} 条`);
            this.count = val;
            this.activityGroupbanjilist()
        },
        //分页事件 点击页数
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.page = val;
            this.activityGroupbanjilist()
        },
        tableRowClassName({ row, rowIndex }) {
            // console.log(row,this.multipleSelection);
            if (
                this.multipleSelection !== null &&
                this.multipleSelection.indexOf(row.id) != -1
            ) {
                return "selected-row"; // 返回的 class 将应用于行元素上
            }
            return ""; // 其他行不应用任何 class
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("addGroupCall", data);
        },
        handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                data: this.form
            }
            this.$emit("addGroupCall", data);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.form = {
                        activity_id: newVal.data.activity_id,
                        id: newVal.data.id,
                        name: newVal.data.name,
                        banji_ids: ''
                    }
                    this.dictionaryGetbanjitype()
                }
            },
            deep: true
        },
        multipleSelection: {
            handler(newVal, oldVal) {
                let checkedArr = JSON.parse(JSON.stringify(newVal))
                this.disabledlist.forEach(item => {
                    checkedArr = checkedArr.filter(v => {
                        return v != item
                    })
                })
                console.log(checkedArr)
                this.form.banji_ids = checkedArr.join(',')
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 1306px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
            }
        }

        .mask-content-body {
            width: 100%;
            background-color: #FFF;
            padding: 20px;

            .mask-content-body-select {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                .mask-content-body-select-title {
                    width: 87px;
                    color: #A6A6A6;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    span {
                        color: #C12E30;
                    }
                }

                .mask-content-body-select-input {
                    flex: 1;

                    .el-select {
                        width: 100%;
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 6px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}
</style>